import { render } from "./Shares_Products.vue?vue&type=template&id=257994f6"
import script from "./Shares_Products.vue?vue&type=script&lang=js"
export * from "./Shares_Products.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__